<template>
  <div class="foot">
    <div class="bottomTitle">
      <img src="../../assets/m/logob.png" />
      <div class="title1">{{ $t("navbar.index") }}</div>
    </div>
    <div class="top">
      <div class="adv">
        <div class="intro l">
          <ul>
            <li class="title">Learning</li>
            <li @click="goPage('/m/About')" class="icon">About DO Network</li>
            <li @click="goPage('/m/Token')" class="icon">DO Token&Economy</li>
            <li >
              <a href="https://fastcdn.donetwork.io/media/DONetwork+whitepaper.pdf" class="icon" target="_blank"
                >White Paper</a
              >
            </li>
            <li @click="goPage('/m/User')" class="icon">User Guide</li>
            <li >
              <a href="https://www.donetwork.io/doc/" class="icon" target="_blank"
                >DO wiki</a
              >
            </li>
            <!-- <li>
              <a
                target="_blank"
                href="https://explorer.donetwork.io/"
                class="icon"
                >Ecology Profolio</a
              >
            </li> -->
            <li @click="goPage('/m/TechRoadmap')" class="icon">Roadmap</li>
            <li @click="goPage('/m/Brand')" class="icon">Brand Kits</li>
            <!-- <li @click="buildPage">
              <a target="_blank" class="icon">{{ $t("Learn.wallet") }}</a>
            </li> -->
          </ul>
        </div>
        <div class="intro">
          <ul>
            <li class="title">Developer</li>
            <li>
              <a
                target="_blank"
                class="icon"
                href="https://www.donetwork.io/doc/developer/"
              >
                <!-- <a
                target="_blank"
                class="icon"
                href="https://fastcdn.donetwork.io/media/DONetwork+whitepaper.pdf"
              > -->
                Developer Documentation</a
              >
            </li>
            <li class="icon">
              <a
                target="_blank"
                class="icon"
                href="https://www.donetwork.io/doc/"
              >
                Deploy Documentation
              </a>
            </li>
            <li class="icon">
              <a
                target="_blank"
                class="icon"
                href="https://www.donetwork.io/doc/json-rpc/"
                >API Documentation</a
              >
            </li>
            <li @click="goPage('/m/GrantApplication')" class="icon">
              <!-- <a
                target="_blank"
                class="icon"
                href="http://47.98.110.210/doc/learn/stake-trustor/stake"
                > -->
              Submit Your Application
              <!-- </a> -->
            </li>
            <li class="icon">
              <a
                target="_blank"
                class="icon"
                href="https://www.donetwork.io/doc/"
              >
                RUN A NODE
              </a>
            </li>
          </ul>
        </div>
      </div>
      <!-- 第二栏开始 -->
      <div class="adv">
        <div class="intro l">
          <ul>
            <li class="title">Community</li>

            <li class="icon" @click="buildPage">Governance</li>
            <!-- <li class="icon" @click="buildPage">
              {{ $t("Developer.application") }}
            </li> -->
            <!-- <li class="icon">
              <a
                href="https://www.donetwork.io/doc/json-rpc"
                target="_blank"
                class="icon"
                >{{ $t("Developer.API") }}</a
              >
            </li>
            <li>
              <a
                href="https://www.donetwork.io/doc/"
                target="_blank"
                class="icon"
                >{{ $t("Developer.Start") }}</a
              >
            </li>
            <li @click="buildPage" class="icon">
              
              {{ $t("Developer.client") }}
             
            </li>
            <li @click="goPage('/m/GrantApplication')" class="icon">
              
              Grant Application
             
            </li> -->
          </ul>
        </div>
        <div class="intro">
          <ul>
            <li class="title">Explore DO network</li>
            <li class="icon">
              <a href="https://explorer.donetwork.io/Index" target="_blank">
                DO Explorer
              </a>
            </li>
            <li class="icon">
              <a
                target="_blank"
                href="https://apps.apple.com/hk/app/sunnywallet/id6633413398"
                >iOS Wallet</a
              >
            </li>
            <li class="icon">
              <a
                target="_blank"
                href="https://fastcdn.donetwork.io/apk/Sunny-Wallet.apk"
                >Android Wallet</a
              >
            </li>
          </ul>
        </div>
      </div>
      <!-- 第二栏结束 -->
      <!-- 第三栏开始 -->
      <div class="adv">
        <div class="intro l">
          <ul>
            <li class="title">Social</li>
            <!-- <router-link to="/m/Blog"> -->
            <li class="icon">
              <a
                href="https://x.com/Donetwork_club"
                target="_blank"
                class="icon"
                >Twitter</a
              >
            </li>
            <!-- </router-link> -->
            <li class="icon">
              <a
                href="https://discord.gg/donetwork"
                target="_blank"
                class="icon"
              >
                Discord
              </a>
            </li>
            <li class="icon">
              <a href="https://t.me/DoNetworkclub" class="icon"> Telegram </a>
            </li>

            <li>
              <a
                href="https://github.com/DONetworkChain"
                target="_blank"
                class="icon"
                >Github</a
              >
            </li>
            <li>
              <a
                href="https://donetwork.medium.com/"
                target="_blank"
                class="icon"
                >Medium</a
              >
            </li>
            <li>
              <a href="https://galxe.com/DONetwork" target="_blank" class="icon"
                >Galxe</a
              >
            </li>
            <li>
              <a
                href="https://zealy.io/cw/donetwork/questboard"
                target="_blank"
                class="icon"
                >Zealy</a
              >
            </li>
          </ul>
        </div>
      </div>
      <!-- 第三栏结束 -->
      <div class="adv">
        <div class="intro">
          <p style="text-align: center">{{ $t("Learn.Powered") }}</p>
        </div>
      </div>
      <!-- 
      <div class="adv-bottom ">
        <div class="intro l b">
          <ul>
            <li class="title">{{ $t("Developer.developer") }}</li>
            <li @click="buildPage">
              <a target="_blank" class="icon">{{
                $t("Developer.documentation")
              }}</a>
            </li>
            <li @click="buildPage">
              <a target="_blank" class="icon">{{
                $t("Developer.application")
              }}</a>
            </li>
            <li @click="buildPage">
              <a target="_blank" class="icon">{{ $t("Developer.API") }}</a>
            </li>
            <li @click="buildPage">
              <a target="_blank" class="icon">{{ $t("footer.runnode") }}</a>
            </li>
            <li @click="buildPage">
              <a
                target="_blank"
                class="icon"
                href="https://www.donetwork.io/doc/learn/stake-trustor/trustor"
                >{{ $t("Developer.client") }}</a
              >
            </li>
          </ul>
        </div>
        <div class="intro">
          <ul>
            <li @click="buildPage">
              <a target="_blank" class="title">
                {{ $t("Community.proposal") }}</a
              >
            </li>
            <li @click="buildPage">
              <a target="_blank" class="icon">{{ $t("Community.pro") }}</a>
            </li>
            <li @click="buildPage">
              <a target="_blank" class="icon">{{ $t("Community.vote") }}</a>
            </li>
            <li @click="buildPage">
              <a target="_blank" class="icon">{{ $t("Community.approve") }}</a>
            </li>
            <li class="icon" @click="goPage('/m/Fund')">
              {{ $t("Community.fund") }}
            </li>
          </ul>
        </div>
        
      </div>
       -->
    </div>
  </div>
</template>

<script>
import { Collapse, CollapseItem } from "vant";
export default {
  components: {
    Collapse,
    CollapseItem,
  },
  data() {
    return {
      shows1: false,
    };
  },
  mounted() {},
  created() {},
  watch: {},
  methods: {
    goPage(url) {
      this.$router.push(url);
      this.show = false;
      this.shows1 = false;
    },
    buildPage() {
      /* const h = this.$createElement;
          this.$message({
            message: h('p', null, [
              h('span', null, 'In Building '),
              h('i', { style: 'color: teal' }, '...'),
            ]),
            type: 'warning',
          }); */
      this.$message({
        message: "In Building...",
        type: "warning",
      });
    },
  },
};
</script>

<style lang="less" scoped>
.foot {
  position: relative;
  left: 0;
  bottom: 0;
  width: 750px;
  height: 1624px;
  background: #000000;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  .bottomTitle {
    padding-top: 96px;
    text-align: center;
    .title1 {
      height: 57px;
      font-size: 44px;
      font-weight: 800;
      color: #ffffff;
      line-height: 57px;
      text-align: left;
    }
    img {
      width: 57px;
      height: 57px;
      opacity: 1;
      float: left;
      margin-left: 50px;
      margin-right: 20px;
    }
  }
  .top {
    padding-top: 101px;
    background: #000000;
    margin: 0 auto;
    .intro {
      flex: 1;
      .k {
        margin-top: 15px;
        margin-left: 0;
        text-align: left;
      }
    }
    .l {
      margin-right: 120px;
    }
    .ContactUs {
      -webkit-margin-top-collapse: separate;
    }
    .b {
      margin-right: 100px;
    }
    .into {
      margin: 60px 0 0 0;
    }
    .adv-bottom {
      cursor: pointer;
      width: 650px;
      // height: 400px;
      margin: 0 auto;
      text-align: left;
      display: flex;
    }
    .adv {
      cursor: pointer;
      width: 650px;
      // min-height: 460px;
      // max-height: 520px;
      margin: 0 auto;
      text-align: left;
      display: flex;
      margin-bottom: 40px;
    }
    .adv-bottom {
      // height: 420px;
      width: 650px;
      // min-height: 420px;
      // max-height: 520px;
      margin: 0 auto;
      text-align: left;
      // padding-bottom: 100px;
    }
    .adv-Border {
      width: 650px;
      height: 225px;
      border-top: 3px solid rgba(255, 255, 255, 0.3);
      display: flex;
      .adv-youxiang {
        flex: 1;
        font-size: 20px;
        font-weight: 400;
        color: #ffffff;
        line-height: 23px;
        -webkit-background-clip: text;
        font-family: Microsoft YaHei UI-Regular, Microsoft YaHei UI;
        margin-top: 82px;
      }
      .adv-youxiang:nth-child(2) {
        margin-left: 82px;
      }
    }
    li {
      margin-bottom: 30px;
    }
  }
  .title {
    font-size: 30px;
    font-weight: 600;
    color: #ffffff;
    line-height: 35px;
  }
  .icon {
    font-size: 24px;
    font-weight: 500;
    color: #939393;
    line-height: 28px;
    width: 288px;
  }
}
</style>
